window.Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.PaymentMethodValidation = (function () {
  function errorNotice() { return $('#form-error-notice'); }
  function paymentError() { return $('.payment-error'); }

  function form() {
    return $('form.product');
  }

  function paymentCheckboxes() {
    return form().find(':checkbox[name=\'product[accepted_payment_methods][]\']');
  }

  function shopSupportsDirectCheckout() {
    return $('[data-shop-supports-direct-checkout]').length > 0;
  }

  function showPaymentErrorIfNeeded() {
    if (errorOnPaymentMethods()) {
      errorNotice().fadeIn();
      paymentError().fadeIn();
      return false;
    }
    paymentError().fadeOut();
    return true;
  }

  function errorOnPaymentMethods() {
    if (paymentCheckboxes().length === 0 || shopSupportsDirectCheckout()) {
      return false;
    }
    return !paymentCheckboxes().is(':checked');
  }

  function handleValidateFormOfPayment() {
    paymentCheckboxes().change(() => {
      showPaymentErrorIfNeeded();
    });

    form().submit(e => showPaymentErrorIfNeeded());
  }

  function init() {
    handleValidateFormOfPayment();
  }

  return {
    init,
    showPaymentErrorIfNeeded,
  };
}());

$(() => {
  Reverb.Listing.PaymentMethodValidation.init();
});
